export var FileStatus;
(function (FileStatus) {
    FileStatus["accepted"] = "accepted";
    FileStatus["rejected"] = "rejected";
})(FileStatus || (FileStatus = {}));
